export default {
  custom: () => import("/home/node/layouts/custom.vue").then(m => m.default || m),
  page: () => import("/home/node/layouts/page.vue").then(m => m.default || m)
}